import { PropsWithChildren } from "react";

import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Icon } from "capitalrx-components-2.0/lib/general";

import styles from "./PlanCard.module.scss";

const PlanCard = ({ children, onClick }: PropsWithChildren & { onClick?: () => void }) => {
  return (
    <div className={styles["plan-card"]} onClick={onClick}>
      <Shelf>
        {children}
        <Shelf.Spacer />
        <Icon name="chevron-right" color="darkgrey" />
      </Shelf>
    </div>
  );
};

export default PlanCard;
